import { render, staticRenderFns } from "./dibu.vue?vue&type=template&id=d54140b2&scoped=true"
import script from "./dibu.vue?vue&type=script&lang=js"
export * from "./dibu.vue?vue&type=script&lang=js"
import style0 from "./dibu.vue?vue&type=style&index=0&id=d54140b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54140b2",
  null
  
)

export default component.exports